import SortablePackagePricing from './SortablePackagePricing';

export default SortablePackagePricing;



// WEBPACK FOOTER //
// ./src/components/Sortable/SortablePackagePricing/index.js